import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { RadioButtons } from "../../../FlowConfigurationInputs";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// TabPanel styling
function TabPanel({ children, value, index }) {
    return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function ExportCsv({ action, setOpenVariable, variables, automId }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.EXCEL.";
    const options = {
        radioButtons: {
            data: [{
                value: ',',
                label: label + 'EXPORT-TO-CSV.COMMA'
            }, {
                value: ';',
                label: label + 'EXPORT-TO-CSV.SEMICOLON'
            }],
            defaultValue: ','
        }
    };
    return (
        <div>
            <div className="form-element">
                <div className="form-element">
                    <FieldLabel name={t(label + 'EXCEL-SOURCE')} is_required />
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                    <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                <FieldLabel name={t(label + 'EXPORT-TO-CSV.SEPARATOR')} />
                <RadioButtons action={action} inputName="separator" options={options.radioButtons} isRequired />
            </div>
            <div className="form-element">
                <FieldLabel name={t(label + 'SAVE.FOLDER-PATH')} is_required />
                <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable}
                    variables={variables} isRequired hideRequired autom_id={automId} />
                <small className="conf-field-desc"><em>e.g.    C:\Autommate\test</em></small>
            </div>
            <div className="form-element">
                <FieldLabel name={t(label + 'OPEN.ASSIGN')} is_required={false} />
                <VariablePicker
                    action={action}
                    inputName="assignToVariable"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    filter="string"
                    isRequired={false}
                    hideRequired
                />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div>
    );
}
export default ExportCsv;